const API_BASE_URL = "https://fixdesk.api.tecnospice.com/";

export default API_BASE_URL;
